module.exports = __webpack_public_path__ + "static/img/web1.74a5886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/webInstavice/web1.png
// module id = C5tF
// module chunks = 1